export class Random
{
    /**
     * Return random float between min (inclusive) and max (exclusive)
     * @param min 
     * @param max 
     */
    public static Range(min:number, max:number)
    {
        return min + (max - min) * Math.random();
    }

    public static Float(max:number)
    {
        return max * Math.random();
    }

    /**
     * Return random integer between min (inclusive) and max (inclusive)
     * @param min 
     * @param max 
     */
    public static RangeInt(min:number, max:number)
    {
        // Make sure min and max are integers
        min = Math.ceil(min);
        max = Math.floor(max);

        // Establish range
        let range = (max - min + 1);

        return min + Math.floor(Math.random() * range);
    }

    /**
     * Returns random integer between 0 (inclusive) and length (exclusive)
     * @param length 
     */
    public static Index(length:number):number
    {
        return this.RangeInt(0, length - 1);
    }

    public static Character(charset:string):string
    {
        return charset.charAt(Random.Index(charset.length));
    }

    /**
     * Randomly shuffles an array
     * @param arr 
     */
    public static Shuffle(arr:any[])
    {
        for (let i = 0; i < arr.length; i++)
        {
            let tmp = arr[i];
            let j:number = Random.Index(arr.length);
            arr[i] = arr[j];
            arr[j] = tmp;
        }
    }
}